import { startImmediate, catchAsync } from "../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Union, toString } from "../fable_modules/fable-library.3.7.20/Types.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { LoadState$2 } from "../Global.js";
import { class_type, getTupleFields, union_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";

export function handleExceptions(x) {
    const a = catchAsync(x);
    return singleton.Delay(() => singleton.Bind(a, (_arg_1) => {
        let _arg;
        return singleton.Return((_arg = _arg_1, (_arg.tag === 1) ? (new FSharpResult$2(1, "Exception: " + toString(_arg.fields[0]))) : _arg.fields[0]));
    }));
}

export function mapError(x) {
    return handleExceptions(singleton.Delay(() => singleton.Bind(x, (_arg_1) => singleton.Return(Result_MapError((_arg) => _arg.fields[0], _arg_1)))));
}

export function fenixApiMapError(x) {
    return handleExceptions(singleton.Delay(() => singleton.Bind(x, (_arg_1) => singleton.Return(Result_MapError((_arg) => _arg.fields[0], _arg_1)))));
}

export function errorToLoadState(x) {
    return singleton.Delay(() => singleton.Bind(x, (_arg_1) => {
        let _arg;
        return singleton.Return((_arg = _arg_1, (_arg.tag === 1) ? (new LoadState$2(3, _arg.fields[0])) : (new LoadState$2(2, _arg.fields[0]))));
    }));
}

export function runApiAndSetState(state, x) {
    startImmediate(singleton.Delay(() => {
        state[1](new LoadState$2(1));
        return singleton.Bind(errorToLoadState(mapError(x)), (_arg) => {
            state[1](_arg);
            return singleton.Zero();
        });
    }));
}

export class Dependency$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Dependency"];
    }
}

export function Dependency$1$reflection(gen0) {
    return union_type("FenixWeb.Api.Dependency`1", [gen0], Dependency$1, () => [[["Item", gen0]]]);
}

export function Dependency$1__get_Value(x) {
    return x.fields[0];
}

export function DependencyModule_value(_arg) {
    return _arg.fields[0];
}

export function DependencyModule_toDepsArray(_arg) {
    const v = _arg.fields[0];
    if (Array.isArray(v)) {
        return getTupleFields(v);
    }
    else {
        return [v];
    }
}

export class Dependency {
    constructor() {
    }
}

export function Dependency$reflection() {
    return class_type("FenixWeb.Api.Dependency", void 0, Dependency);
}

export function Dependency_from_244D3E44(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z524259E6(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z524259A4(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z524259C1(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_32C73145(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z721C83C5(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z1FBCCD16(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_5E38073B(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_244AC511(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_7FA2F3CE(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_7F9DDECF(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z53C0511E(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z2F40E90F(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_401972F(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_4019FA9(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_4018BEA(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_663BEA50(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_2297AD2E(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_73E1A31F(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_77EFFD2E(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z2F9AE9BC(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z17374585(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z18EF7CE6(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_57B7DC57(v) {
    return new Dependency$1(0, v);
}

export function Dependency_from_Z230E7DE0(a, b) {
    return new Dependency$1(0, [DependencyModule_value(a), DependencyModule_value(b)]);
}

export function Dependency_from_Z2AFB4231(a, b, c) {
    return new Dependency$1(0, [DependencyModule_value(a), DependencyModule_value(b), DependencyModule_value(c)]);
}

export function Dependency_from_Z2446F3C0(a, b, c, d) {
    return new Dependency$1(0, [DependencyModule_value(a), DependencyModule_value(b), DependencyModule_value(c), DependencyModule_value(d)]);
}

export function System_Byte__Byte_get_AsDep(x) {
    return Dependency_from_244D3E44(x);
}

export function System_Int16__Int16_get_AsDep(x) {
    return Dependency_from_Z524259E6(x);
}

export function System_Int32__Int32_get_AsDep(x) {
    return Dependency_from_Z524259A4(x);
}

export function System_Int64__Int64_get_AsDep(x) {
    return Dependency_from_Z524259C1(x);
}

export function System_Decimal__Decimal_get_AsDep(x) {
    return Dependency_from_32C73145(x);
}

export function System_String__String_get_AsDep(x) {
    return Dependency_from_Z721C83C5(x);
}

export function System_Boolean__Boolean_get_AsDep(x) {
    return Dependency_from_Z1FBCCD16(x);
}

export function System_Double__Double_get_AsDep(x) {
    return Dependency_from_5E38073B(x);
}

export function System_Guid__Guid_get_AsDep(x) {
    return Dependency_from_244AC511(x);
}

export function System_DateOnly__DateOnly_get_AsDep(x) {
    return Dependency_from_7FA2F3CE(x);
}

export function System_DateTime__DateTime_get_AsDep(x) {
    return Dependency_from_7F9DDECF(x);
}

export function System_DateTimeOffset__DateTimeOffset_get_AsDep(x) {
    return Dependency_from_Z53C0511E(x);
}

export function useApiCall(args, apiCall) {
    const state = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        startImmediate(singleton.Delay(() => {
            state[1](new LoadState$2(1));
            const y = errorToLoadState(apiCall(DependencyModule_value(args)));
            return singleton.Bind(y, (_arg) => {
                state[1](_arg);
                return singleton.Return();
            });
        }));
    }, DependencyModule_toDepsArray(args));
    return state;
}

